import { render, staticRenderFns } from "./reg-1.vue?vue&type=template&id=7949d3d0&lang=pug&"
import script from "./reg-1.vue?vue&type=script&lang=js&"
export * from "./reg-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports